import React from "react";
import Carousel from "react-multi-carousel";
import { Link } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";

import { useTheme } from "../context/ThemeContext";

const Categorys = ({ categorys }) => {
  const { getBackground } = useTheme();

  // Filtrar solo las categorías que tienen imagen válida y están publicadas
  const filteredCategories = (categorys || []).filter(c => c.verpublish !== false && c.image && c.image.trim() !== "");

  // Mostrar solo las primeras 5 categorías filtradas
  const limitedCategories = filteredCategories.slice(0, 5);

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: Math.min(limitedCategories.length, 5),
    },
    tablet: {
      breakpoint: { max: 1023, min: 641 },
      items: Math.min(limitedCategories.length, 3),
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: Math.min(limitedCategories.length, 2),
    },
  };

  return (
    <div className="w-[87%] lg:w-[87%] md:w-[95%] sm:w-full mx-auto relative px-4 lg:px-20 md:px-6">
      {/* Título centrado verticalmente */}
      <div className="w-full flex items-center justify-center mt-1 mb-4">
        <div className="text-center">
          <h2 className="text-3xl text-slate-600 font-bold">NUESTRAS CATEGORÍAS</h2>
          <div style={{ ...getBackground("background") }} className="w-[100px] h-[2px]  mt-4 mx-auto"></div>
        </div>
      </div>

      <Carousel autoPlay={true} infinite={true}
        arrows={true} responsive={responsive} transitionDuration={500}
        containerClass="gap-4" itemClass="px-2 sm:h-auto">
        {limitedCategories.map((c, i) => (
          <Link
            className="h-[220px] sm:h-auto border-2 border-gray-300 block rounded-lg overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-lg"
            key={i}
            to={`/products/search?category=${c.name}`}>
            <div className="w-full h-full relative p-0">
              <img
                src={c.image}
                alt={c.name}
                className="w-full h-full sm:h-auto sm:object-contain md:object-cover xl:object-cover rounded-lg"
                loading="lazy"
              />
            </div>
          </Link>
        ))}
      </Carousel>
    </div>
  );
};

export default React.memo(Categorys);
